import { render, staticRenderFns } from "./lever_dealCenter.vue?vue&type=template&id=b85915e0&scoped=true&"
import script from "./lever_dealCenter.vue?vue&type=script&lang=js&"
export * from "./lever_dealCenter.vue?vue&type=script&lang=js&"
import style0 from "./lever_dealCenter.vue?vue&type=style&index=0&id=b85915e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85915e0",
  null
  
)

export default component.exports